// Mirrors Audit::RecipeIndex in core: "." separated runs of consecutive ids, each written as the
// base36 delta from the end of the previous run with an optional "-<base36 extra length>" suffix.
export const decodeRecipeIndex = (encoded?: string): Set<number> => {
  const ids = new Set<number>()
  let previous = 0

  for (const token of (encoded ?? '').split('.')) {
    if (!token) continue

    const [delta, extra] = token.split('-')
    const first = previous + parseInt(delta, 36)
    previous = first + (extra ? parseInt(extra, 36) : 0)
    for (let id = first; id <= previous; id++) ids.add(id)
  }

  return ids
}
